import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const LogoutButton: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { signOut, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) return null;

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await signOut();
      // Force a small delay to ensure auth state is updated
      setTimeout(() => {
        navigate('/welcome', { replace: true });
      }, 100);
    } catch (error) {
      console.error('Logout failed:', error);
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className="fixed top-4 right-4 px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 disabled:opacity-50"
      aria-label={isLoading ? "Signing out" : "Logout"}
    >
      {isLoading ? "Signing out..." : "Logout"}
    </button>
  );
};

export default LogoutButton;